import { useLocation, useNavigate } from "react-router-dom";
import { STRING, STRINGS } from "../constant";
import { IMAGES, SVG_IMAGES } from "../assets";
import { Header, LAView, LAText } from "../components";
import HTMLContent from "../components/HTMLContent";
import ExplanationComponent from "../components/ExplanationComponent";
import AnswerMessage from "../components/AnswerMessage";
import NavBar from "../components/NavBar";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import IconTint from "react-icon-tint";
import { AuthContext } from "../context/AuthProvider";
import { useContext, useEffect, useState } from "react";
import { BundleContext } from "../context/BundleProvider";
import { GET_COMMUNITY_SINGLE_QUESTION_DETAILS } from "../api/community";
import { GET_APP_DOMAIN_LIST } from "../../app_constant";
import OptionButton from "../components/question/OptionButton";
import BackArrowIcon from "../components/BackArrowIcon";
import { ThemeContext } from "../context/ThemeProvider";
import { MixpanelContext } from "../context/MixpanelProvider";
import QuestionOptions from "../components/question/QuestionOptions";
import BookmarkIcons from "../components/BookmarkIcons";
import CommunityPopup from "./quickSet/CommunityPopup";
import TabFooter from "../components/TabFooter";
import { GET_QUESTION_FROM_ID } from "../api/test";
import useFeatureList from "../hooks/useFeatureList";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUsers, 
  faBookmark, 
  faChevronLeft, 
  faChevronRight,
  faQuestionCircle,
  faBook
} from '@fortawesome/free-solid-svg-icons';
import { getPracticeTestIconBg, getBookMarkColor } from "../utils/themeUtils";

function QuestionReview() {
  const { state } = useLocation();
  const { theme, currentTheme } = useContext(ThemeContext);
  const { trackQuestionBookmark } = useContext(MixpanelContext);
  const title = state?.title;
  const item = state?.item;
  const questions = state?.state;
  const lastReadinessScore = state?.lastReadinessScore;
  const featureList = useFeatureList();

  const {
    profile,
    questionsList,
    addQuestionToBookmark,
    removeQuestionFromBookmark,
    isVisibleCommunity,
  } = useContext(AuthContext);
  const navigate = useNavigate();
  const { selectedCertificate } = useContext(BundleContext);

  const [isLoadingCommunityData, setLoadingCommunityData] = useState(false);
  const [quickSetState, setQuickSetState] = useState({
    selectedOpion: null,
  });
  const [currentIndex, setCurrentIndex] = useState(0);
  const [communityQuestion, setCommunityQuestion] = useState(null);
  const [isCommunityPopup, setCommunityPopup] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [savedAnswers, setSavedAnswers] = useState([]);
  const OPTIONS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

  // Card animations
  const cardVariants = {
    hover: { 
      scale: 1.01,
      boxShadow: "0px 4px 10px rgba(0,0,0,0.05)",
      transition: { type: "spring", stiffness: 400, damping: 15 }
    }
  };

  // Helper function to get icon background color
  const getIconBg = () => {
    return getPracticeTestIconBg(theme, currentTheme);
  }

  // Helper function to get card background
  const getCardBackground = (iconBg) => {
    const baseColor = currentTheme === 'light' ? theme?.homeCard?.start_light : theme?.homeCard?.start_dark;
    const darkerShade = currentTheme === 'light' ? theme?.homeCard?.end_light : theme?.homeCard?.end_dark;
    return {
      background: `linear-gradient(to right, ${baseColor}, ${darkerShade})`,
      // borderLeft: `4px solid ${iconBg || getPracticeTestIconBg(theme, currentTheme)}`
    };
  };

  // Helper function for text color
  const getTextColor = () => {
    return currentTheme === 'light' 
      ? theme?.text?.light
      : theme?.text?.dark;
  };

  const getColorGreen = () => { 
    return theme?.color.green.main;
  }

  const getColorRed = () => {
    return theme?.color.red.main;
  };

  const getColorGray = () => {
    return theme?.color.gray.main;
  }

  const getNavBackground = () => {
    return currentTheme === 'light' ? theme?.homeCard?.end_light : theme?.homeCard?.end_dark
  };

  
  

  const QuestionReviewOption = ({ optionText, optionLetter, correctAnswer, selectedAnswer }) => {
    // Function to determine if option is in an array or matches a character
    const isOptionIncluded = (option, target) => {
      if (Array.isArray(target)) {
        return target.includes(option);
      }
      return option === target;
    };
  
    // Determine the background color based on the logic
    const getBackgroundColor = () => {
      const isCorrect = isOptionIncluded(optionLetter, correctAnswer);
      const isSelected = isOptionIncluded(optionLetter, selectedAnswer);
      
      if (isCorrect) {
        return getColorGreen(); // Green background for correct answers
      } else if (isSelected) {
        return getColorRed(); // Red background for incorrect selections
      } else {
        return getColorGray(); // Gray background for unselected and incorrect options
      }
    };
  
    return (
      <div
      
      className="h-full flex flex-col rounded-xl overflow-hidden shadow-sm"
      style={{
        
        border: `1px solid ${getBackgroundColor()}`,
      }}
    >
      <div className="flex-1 flex items-stretch">
        {/* Option content */}
        <div className="flex-1 p-4">
          <HTMLContent index={optionText.length} htmlContent={optionText} />
        </div>
        
        {/* Option letter */}
        <div 
          className="flex items-center justify-center px-6"
          style={{ 
            backgroundColor: getBackgroundColor(),
            color: getTextColor(),
            borderLeft: `1px solid ${getBackgroundColor()}`
          }}
        >
          <span className="text-xl font-medium">
            {optionLetter}
          </span>
        </div>
      </div>
    </div>

      
    );
  };
  

  useEffect(() => {
    if (isVisibleCommunity) {
      setCommunityQuestion(null);

      if (questions?.length > 0 && !isNaN(currentIndex)) {
        const question = questions[currentIndex];
        getCommunityQuestion(question.question_id);
      }
    }
  }, [currentIndex]);

  function getCurrentQuestion() {
    if (questions?.length > 0 && !isNaN(currentIndex)) {
      const id = questions[currentIndex].question_id;
      return GET_QUESTION_FROM_ID(questionsList, id);
    }

    return null;
  }

  function getTopicId() {
    const APP_DOMAIN_LIST = GET_APP_DOMAIN_LIST(selectedCertificate);
    const array = APP_DOMAIN_LIST?.find(
      (item) => item?.id == questions[currentIndex]?.topic_id
    );
    return array?.domain_name ?? "";
  }

  function onBack() {
    navigate("/testReview", { state: { historyData: item, canGoBackKey: false, lastReadinessScore } });
  }

  function onPrevious() {
    setCurrentIndex((state) => {
      return state == 0 ? 0 : state - 1;
    });
  }

  function onNext() {
    setCurrentIndex((state) => {
      return state == questions?.length - 1 ? 0 : state + 1;
    });
  }

  function onBookmark() {
    if (questions?.length > currentIndex) {
      const question = questions[currentIndex];
      if (isBookmark) {
        trackQuestionBookmark(-1);
        removeQuestionFromBookmark(question.question_id);
      } else {
        trackQuestionBookmark(1);
        addQuestionToBookmark(question.question_id);
      }
    }
  }

  function checkBookmark() {
    if (questions?.length > currentIndex) {
      const question = questions[currentIndex];
      return (
        profile?.question_bookmarks?.includes(question.question_id) ?? false
      );
    }

    return false;
  }

  async function getCommunityQuestion(id) {
    try {
      setLoadingCommunityData(true);
      const result = await GET_COMMUNITY_SINGLE_QUESTION_DETAILS(id);
      setLoadingCommunityData(false);
      if (result.data) {
        setCommunityQuestion(result.data);
      } else {
        setCommunityQuestion(null);
      }
    } catch (error) {
      console.error(error);
      setCommunityQuestion(null);
    }
  }

  function getCommunityQuestionPercentage() {
    if (communityQuestion && isVisibleCommunity) {
      const percentage =
        (communityQuestion?.times_answered_correct /
          communityQuestion?.times_answered) *
        100;
      if (isNaN(percentage) || !isFinite(percentage)) {
        return {
          color: theme.COLOR_RED,
          percentage: 0,
          message: STRING.community_popup_desc_less_50,
        };
      } else if (percentage < 50) {
        return {
          color: theme.COLOR_RED,
          percentage: 0,
          message: STRING.community_popup_desc_less_50,
        };
      } else if (percentage < 80) {
        return {
          color: theme.COLOR_YELLOW,
          percentage: 0,
          message: STRING.community_popup_desc_less_80,
        };
      } else {
        return {
          color: theme.COLOR_GREEN,
          percentage: 0,
          message: STRING.community_popup_desc_less_100,
        };
      }
    }

    return {
      percentage: 0,
      message: STRING.community_popup_desc_less_50,
    };
  }

  function onPressCommunity() {
    setCommunityPopup(true);
  }

  const isBookmark = checkBookmark();
  const currentItem = getCurrentQuestion();
  const topic = getTopicId();
  const communitySettings = getCommunityQuestionPercentage();

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex items-center mb-6">
        <button
          className="rounded-lg border-2 p-2 mr-4 flex items-center justify-center"
          style={{ borderColor: currentTheme === "light" ? theme?.border_color?.light : theme?.border_color?.dark }}
          onClick={onBack}
        >
          <BackArrowIcon
            color={currentTheme === "light" ? theme?.text?.light : theme?.text?.dark}
          />
        </button>
        <h1 
          className="text-2xl font-semibold"
          style={{ color: getTextColor() }}
        >
          Review Test ({title} Questions)
        </h1>
      </div>

      {/* Question Navigation and Bookmark */}
      <div className="flex items-center justify-between mb-6">
        <div 
              className="flex items-center px-4 py-2 rounded-lg"
              style={{ 
                backgroundColor:  currentTheme == 'light' ? getNavBackground() : getIconBg(),
                color: currentTheme == 'light' ? getIconBg() : getTextColor(),
              }}
              >
              <FontAwesomeIcon icon={faQuestionCircle} className="mr-2" style={{ color: currentTheme == 'light' ? getIconBg() : getTextColor(), }}/>
              <span className="font-bold" style={{ color: currentTheme == 'light' ? getIconBg() : getTextColor(), }}>
                {`${STRINGS.question} ${currentIndex + 1}`}
              </span>
              <span className="text-sm ml-1 text-black dark:text-white">
                / {questions.length}
              </span>
            </div>
        <div className="flex items-center space-x-3">
          {communityQuestion && featureList?.global.community_score && (
            <button
              className="p-2 rounded-lg transition-colors"
              onClick={onPressCommunity}
              style={{ 
                color: communitySettings?.color || getIconBg()
              }}
            >
              <FontAwesomeIcon icon={faUsers} className="text-xl" />
            </button>
          )}
          
          {featureList?.global.bookmark && (
            <button
              className="p-2 rounded-lg transition-colors"
              onClick={onBookmark}
              style={{ 
                backgroundColor: 'transparent',
                color: getBookMarkColor(currentTheme,isBookmark)
              }}
            >
              <FontAwesomeIcon 
                icon={faBookmark} 
                className={isBookmark ? 'text-2xl' : 'text-2xl text-gray-400'} 
              />
            </button>
          )}
        </div>
      </div>

      {currentItem && questions?.length > 0 ? (
        <motion.div
          className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-sm mb-6"
          whileHover="hover"
          variants={cardVariants}
        >
          <div style={getCardBackground(getIconBg())}>
            <div className="p-6">
              {/* Question Content */}
              <div className="mb-6">
                <HTMLContent 
                  htmlContent={currentItem?.question?.question}
                  className="prose dark:prose-invert max-w-none"
                  style={{ color: getTextColor() }}
                />
              </div>

              {/* Answer Options */}
              <div className="grid gap-3 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
                {currentItem?.choices?.map((options, index) => (
                  <QuestionReviewOption
                    key={index}
                    optionText={options}
                    optionLetter={OPTIONS?.[index]}
                    correctAnswer={currentItem?.question?.correct_answer}
                    selectedAnswer={state?.state[currentIndex]?.selected_choice}
                  />
                  
                ))}
              </div>

              {/* Answer and Explanation */}
              <div className="mt-8 pt-6 border-t" style={{ borderColor: 'rgba(0,0,0,0.1)' }}>
                <AnswerMessage
                  correct_answer={currentItem?.question?.correct_answer}
                  selected_answer={state?.state[currentIndex]?.selected_choice}
                />
                <ExplanationComponent
                  explanation={currentItem.question?.explanation ?? ""}
                  topic={topic}
                  sub_domain={
                    currentItem?.question?.sub_domain
                      ? currentItem?.question?.sub_domain
                      : ""
                  }
                />
              </div>
            </div>
          </div>
        </motion.div>
      ) : null}

      {/* Navigation Controls */}
      <NavBar
        theme={theme}
        currentTheme={currentTheme}
        onNext={onNext}
        onPrevious={onPrevious}
        iconBg={getIconBg()}
        currentIndex={currentIndex}
        dataSet={questions?.length ?? 0}
        navTitle="Question"
        showEnd={false}
        onEndTest={() => {}}
      />
      

      {/* Community Popup */}
      <AnimatePresence>
        {isCommunityPopup && (
          <CommunityPopup
            communitySettings={communitySettings}
            onCancle={() => {
              setCommunityPopup(false);
            }}
          />
        )}
      </AnimatePresence>
    </div>
  );
}

export default QuestionReview;